var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84853 16.6666C8.27809 16.6666 8.62631 16.3184 8.62631 15.8889C8.62631 15.4593 8.27809 15.1111 7.84853 15.1111H5.98884L9.10556 11.9944C9.4093 11.6907 9.4093 11.1982 9.10556 10.8944C8.80182 10.5907 8.30936 10.5907 8.00562 10.8944L4.88905 14.011V11.4444C4.88905 11.0149 4.54082 10.6666 4.11127 10.6666C3.68171 10.6666 3.33349 11.0149 3.33349 11.4444L3.33349 15.8732C3.3294 16.0774 3.40528 16.283 3.56114 16.4388C3.6523 16.53 3.76045 16.5938 3.87541 16.6302C3.9498 16.6539 4.02904 16.6666 4.11127 16.6666H7.84853Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3737 4.11114C11.3737 3.68158 11.7219 3.33336 12.1515 3.33336L15.8887 3.33336C15.971 3.33336 16.0502 3.34612 16.1246 3.36977C16.2395 3.40621 16.3477 3.47001 16.4389 3.56117C16.5947 3.71703 16.6706 3.92257 16.6665 4.12681V8.55558C16.6665 8.98514 16.3183 9.33336 15.8887 9.33336C15.4592 9.33336 15.111 8.98514 15.111 8.55558V5.98901L11.9944 9.10556C11.6906 9.4093 11.1982 9.40929 10.8944 9.10555C10.5907 8.80181 10.5907 8.30935 10.8944 8.00561L14.0112 4.88892L12.1515 4.88892C11.7219 4.88892 11.3737 4.54069 11.3737 4.11114Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 0C1.49238 0 0 1.49238 0 3.33333V16.6667C0 18.5076 1.49238 20 3.33333 20H16.6667C18.5076 20 20 18.5076 20 16.6667V3.33333C20 1.49238 18.5076 0 16.6667 0H3.33333ZM16.6667 1.44444H3.33333C2.29013 1.44444 1.44444 2.29013 1.44444 3.33333V16.6667C1.44444 17.7099 2.29013 18.5556 3.33333 18.5556H16.6667C17.7099 18.5556 18.5556 17.7099 18.5556 16.6667V3.33333C18.5556 2.29013 17.7099 1.44444 16.6667 1.44444Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.841edc94cb8a505d4b73bdc5b330c0ad.svg";
export { ForwardRef as ReactComponent };